import { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { resetAdminPassword } from "../../features/adminAuth/adminAuthStorage";

const AdminResetPasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const tokenFromLink = String(searchParams.get("token") || "").trim();
  const emailFromLink = String(searchParams.get("email") || "").trim();

  const [email, setEmail] = useState(emailFromLink);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!tokenFromLink) {
      setError("Reset token is missing. Use the full link from your email.");
      return;
    }

    if (!email.trim()) {
      setError("Email is required.");
      return;
    }

    if (!password.trim()) {
      setError("New password is required.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setSubmitting(true);
    const result = await resetAdminPassword({ token: tokenFromLink, email, password });
    if (!result.ok) {
      setError(result.message);
      setSubmitting(false);
      return;
    }

    setSuccess(result.message || "Password reset successful. Redirecting to admin login...");
    setSubmitting(false);

    setTimeout(() => {
      navigate("/admin/login", { replace: true });
    }, 900);
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <h1>Reset Admin Password</h1>
        <p>Set a new password for your admin account.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="adminResetEmail">Email</label>
          <input
            id="adminResetEmail"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="admin@verixxon.com"
            required
          />

          <label htmlFor="adminNewPassword">New Password</label>
          <input
            id="adminNewPassword"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Enter new password"
            required
          />

          <label htmlFor="adminConfirmPassword">Confirm New Password</label>
          <input
            id="adminConfirmPassword"
            type="password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            placeholder="Re-enter new password"
            required
          />

          {error ? <p className="auth-error">{error}</p> : null}
          {success ? <p className="auth-success">{success}</p> : null}

          <button type="submit" disabled={submitting}>
            {submitting ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        <p className="auth-switch">
          Return to <Link to="/admin/login">Admin login</Link>
        </p>
      </section>
    </main>
  );
};

export default AdminResetPasswordPage;
